// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3YbfU","errors":"Errors_errors__DjmuQ"};